// Length of the animation is MS
const animationDuration = 1000;

// lenght of the animation in S
const frameDuration = 1000 / 60;

// Number of frames to complete the animation
const totalFrames = Math.round( animationDuration / frameDuration );

const countupEls = document.querySelectorAll( '.countup' );

// An ease-out function that slows the count as it progresses
const easeOutQuad = t => t * ( 2 - t );

// The animation function, which takes an Element
const animateCountUp = el => {
    let frame = 0;
    const countTo = parseInt( el.innerHTML, 10 );
    // Start the animation running 60 times per second
    const counter = setInterval( () => {
        frame++;
        // Calculate our progress as a value between 0 and 1
        // Pass that value to our easing function to get our
        // progress on a curve
        const progress = easeOutQuad( frame / totalFrames );
        // Use the progress value to calculate the current count
        const currentCount = Math.round( countTo * progress );

        // If the current count has changed, update the element
        if ( parseInt( el.innerHTML, 10 ) !== currentCount ) {
            el.innerHTML = currentCount;
        }

        // If we’ve reached our last frame, stop the animation
        if ( frame === totalFrames ) {
            clearInterval( counter );
        }
    }, frameDuration );
};

// Run the animation on all elements with a class of ‘countup’
const runAnimations = (entries) => {
    entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
            countupEls.forEach( animateCountUp )
            observer.unobserve(mainFigures);
        }
    });
    
};


const mainFigures = document.querySelector('.main-figures');

const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
}


const observer = new IntersectionObserver(runAnimations, options);
if (mainFigures) observer.observe(mainFigures);

